import { Button, Title3 } from '@fluentui/react-components';
import { SettingsRegular } from '@fluentui/react-icons';
import { BrandMark, usePaneStyles } from './styles';

interface HeaderProps {
  title: string;
  onSettings?: () => void;
  onBack?: () => void;
}

export function Header({ title, onSettings, onBack }: HeaderProps) {
  const styles = usePaneStyles();
  return (
    <div className={styles.header}>
      <BrandMark className={styles.headerIcon} />
      <Title3 className={styles.headerTitle} as="h1" style={{ margin: 0, fontSize: 15 }}>
        {title}
      </Title3>
      <div className={styles.headerAction}>
        {onBack ? (
          <Button appearance="subtle" size="small" onClick={onBack}>
            Back
          </Button>
        ) : onSettings ? (
          <Button
            appearance="subtle"
            icon={<SettingsRegular />}
            aria-label="Settings"
            onClick={onSettings}
          />
        ) : null}
      </div>
    </div>
  );
}
